<template>
  <file-select
    :initDest="parent"
    @dest-change="onTargetChange"
    @close-select="onCloseSelect"
  >
    <div :class="{'disable': disableAction}" @click="handleAction">{{ $t(`file.action.${actionName}`) }}</div>
  </file-select>
</template>
<script>
import {i18n} from '@/utils/i18n'
import FileSelect from './FileSelect'
import fileActions from '@/utils/fileActions'
import { getParentItem } from '@/utils/fileUtils'
import { toast } from '@/utils/common'

export default {
  name: 'MoveCopy',
  components: {
    FileSelect
  },
  i18n,
  props: {
    actionName: String,
    actionItem: Object,
    actionFrom: String
  },
  data () {
    return {
      parent: {},
      target: {},
      listInfo: {},
      showSelectNav: false,
      showCreateFolder: false
    }
  },
  computed: {
    disableAction () {
      const permissions = this.target.permissions || []
      if (this.actionItem.type === 'file') {
        return !permissions.includes('item_upload')
      } else {
        return !permissions.includes('create_folder') && !permissions.includes('item_upload')
      }
    }
  },
  watch: {
  },
  created () {
    let parent = this.$route.params
    if (['header', 'frequent', 'search', 'preview'].includes(this.actionFrom)) {
      parent = getParentItem(this.actionItem)
    }
    this.parent = parent
  },
  methods: {
    onTargetChange (item) {
      this.target = item
    },
    onCloseSelect () {
      this.toggleQuery('movecopy')
    },
    handleAction () {
      if (this.disableAction) {
        toast.fail(i18n.t('base.noPermission'))
        return
      }
      fileActions.handleMoveCopy(this.actionName, {
        item_typed_ids: this.actionItem.typed_id,
        target_folder_id: this.target.isDepartment || this.target.id === undefined ? 0 : this.target.id,
        department_id: this.target.isDepartment ? this.target.id : undefined
      }).then(res => {
        // 如果操作的item被删 结束操作
        if (res.error_type === 'item') {
          this.toggleQuery('movecopy')
        } else if (res.success) {
          if (this.actionName === 'move') {
            if (this.actionFrom !== 'frequent' && this.actionFrom !== 'search') {
              this.setState({
                actionState: {
                  action: 'delete',
                  type: this.actionItem.type,
                  id: this.actionItem.id
                }
              })
            } else {
              this.actionItem.path = res.current_path
              this.actionItem.space = res.new_parent.space
              this.actionItem.department = res.new_parent.department
            }
          } else if (this.actionFrom !== 'frequent' && this.actionFrom !== 'search') {
            // spaceInfo: 存储当前目录位置，供文件列表判断复制生成项是否要插入列表中
            this.setState({newFolder: Object.assign(res.files_and_folders ? res.files_and_folders[0] : {}, {spaceInfo: this.selectListPeek})})
          }
          this.toggleQuery('movecopy')
        }
      })
    }
  }
}
</script>
